import { UnauthorizedError, ServerError, FetchError, NotFoundError } from './FlightServiceError';

export class FlightErrorHandler {
    handle(error: any): never {
        console.error('FlightService: Error fetching flights:', error);

        if (error?.status === 401) {
            throw new UnauthorizedError();
        }

        if (error?.status === 404) {
            throw new NotFoundError();
        }

        if (error?.status >= 500) {
            throw new ServerError(error.status);
        }

        throw new FetchError(error instanceof Error ? error : undefined);
    }
}

export const flightErrorHandler = new FlightErrorHandler();

